import { memo, useCallback } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { ReservationServiceView, ReservationServiceResourceView } from 'models';

import { PageTitle } from 'containers';
import ReservationItem from './reservation-item';
import { PageLoader, Error, NoData } from 'components';
import { useStyles } from './style';

interface Props {
  reservationServices: ReservationServiceView[];
  selectServiceResource: (
    resource: ReservationServiceResourceView | null,
    serviceId: string | null,
    slotDuration: number | null
  ) => void;
  loading: boolean;
  error: boolean;
}

const ServiceDetails: React.FC<Props> = ({
  reservationServices,
  selectServiceResource,
  loading,
  error,
}) => {
  const location = useLocation();
  const history = useHistory();
  const classes = useStyles();

  const handleClick = useCallback(
    (
      resource: ReservationServiceResourceView,
      serviceId: string | null,
      slotDuration: number | null
    ) => {
      selectServiceResource(resource, serviceId, slotDuration);
      history.push(`${location.pathname}/${resource.Id}`);
    },
    [history, location.pathname]
  );

  if (error) {
    return <Error />;
  }

  if (loading) {
    return <PageLoader />;
  }

  if (!reservationServices.length) {
    return <NoData />;
  }

  return (
    <>
      <PageTitle />
      <div>
        {reservationServices.map((service) => {
          const { SlotDuration, Name, Id: ServiceId, Resources } = service;

          return (
            <div key={ServiceId} className={classes.reservationRoot}>
              <h4 className={classes.blockTitle}>{Name}</h4>
              <div className={classes.boxWrapper}>
                {Resources.map((resource) => {
                  return (
                    <ReservationItem
                      key={resource.Id}
                      serviceId={service.Service?.Id || null}
                      resource={resource}
                      slotDuration={SlotDuration}
                      onOpen={handleClick}
                    />
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
};

export default memo(ServiceDetails);
